import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAllFederalReligiousData,
  fetchDefaultFederalList,
} from "./FederalReligiousActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

// change names and insitial state
const practiceAllFederalList = createSlice({
  name: "practiceAllFederalList",
  initialState: {
    isPracticeAllFederalListLoading: false,
    practiceAllFederalList: [],
    isFederalError: null,
    isFederalErrorMsg: null,
  },
  reducers: {
    updatePracticeInfoDetails: (state, action) => {
      state.practiceAllFederalList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllFederalReligiousData.pending, (state) => {
        state.isPracticeAllFederalListLoading = true;
        state.isFederalError = null;
      })
      .addCase(fetchAllFederalReligiousData.fulfilled, (state, action) => {
        state.isPracticeAllFederalListLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.federaReligiouslDefaultValues = [];
            state.isFederalError = false;
          } else {
            state.isFederalError = true;
            state.isFederalErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.isFederalError = false;
          state.practiceAllFederalList = action.payload.data?.data?.HolidayDTO;
        }
      })
      .addCase(fetchAllFederalReligiousData.rejected, (state, action) => {
        state.isPracticeAllFederalListLoading = false;
        state.isFederalError = action.error.message;
      });
  },
});

const practiceFederalReligiousDefault = createSlice({
  name: "practiceFederalReligiousDefault",
  initialState: {
    isFederalReligiousLoading: false,
    federaReligiouslDefaultValues: [],
    federalDefaultError: null,
    federalDefaultErrorMsg: null,
  },
  reducers: {
    updateDefaultHolidayDetails: (state, action) => {
      state.federaReligiouslDefaultValues = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDefaultFederalList.pending, (state) => {
        state.isFederalReligiousLoading = true;
        state.federalDefaultError = null;
      })
      .addCase(fetchDefaultFederalList.fulfilled, (state, action) => {
        state.isFederalReligiousLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.federaReligiouslDefaultValues = [];
            state.federalDefaultError = false;
          } else {
            state.federalDefaultError = true;
            state.federalDefaultErrorMsg = getApiErrorMessage(
              action.payload.status
            );
          }
        } else {
          state.federalDefaultError = false;
          state.federaReligiouslDefaultValues =
            action.payload.data?.data?.practiceHolidayDTO;
        }
      })
      .addCase(fetchDefaultFederalList.rejected, (state, action) => {
        state.isFederalReligiousLoading = false;
        state.federalDefaultError = action.error.message;
      });
  },
});

export const practiceAllFederalListReducer = practiceAllFederalList.reducer;
export const { updateDefaultHolidayDetails } =
  practiceFederalReligiousDefault.actions;
export const practiceFederalReligiousDefaultReducer =
  practiceFederalReligiousDefault.reducer;
